import { axiosInfraInstance } from '.';

export const GetControllerList = async (partnerId, organisationId) => {
  const url = `/infrastructureManagement/v1/organisations/${organisationId}/controllers`;
  return await axiosInfraInstance({ method: 'Get', url: url });
};

export const AddController = async (partnerId, organisationId, payload, networkId) => {
  const url = `/infrastructureManagement/v1/networks/${networkId}/accessPoints`;
  return await axiosInfraInstance({ method: 'Post', url: url, data: payload });
};
export const EditController = async (partnerId, organisationId, payload, networkId, id) => {
  const url = `/infrastructureManagement/v1/accessPoints/${id}`;
  return await axiosInfraInstance({ method: 'Patch', url: url, data: payload });
};

export const DeleteController = async (partnerId, organisationId, controllerId) => {
  console.log({ controllerId })
  const url = `/infrastructureManagement/v1/controllers/${controllerId}`;
  return await axiosInfraInstance({ method: 'Delete', url: url });
};

export const GetSupportedAccessTypes = async (organisationId, deviceSerialNumber) => {
  const url = `/infrastructureManagement/v1/organisations/${organisationId}/devices/${deviceSerialNumber}/supportedAccessType`;
  return await axiosInfraInstance({ method: 'get', url: url });
};

export const GetSpintlySerialNumber = async (vendorSerialNumber) => {
  const url = `/infrastructureManagement/v1/azure/vendorSerialNumber/${vendorSerialNumber}`;
  return await axiosInfraInstance({ method: 'get', url: url });
};

